import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';

@Injectable({
    providedIn: 'root'
})

export class ExportService {
    constructor() { }

    fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    fileExtension = '.xlsx';

    public exportExcel(jsonData: any[], fileName: string): void {
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
        const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        this.saveExcelFile(excelBuffer, fileName);
    }

    private saveExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: this.fileType });
        FileSaver.saveAs(data, fileName + this.fileExtension);
    }
    
    public exportPDF(idDiv: string, nomeDoArquivo: string, textFile?: string) {
        const div = document.getElementById(idDiv);
        const options = {
          scale: 1,
          background: 'white',
        };
        html2canvas(div, options).then((canvas) => {
          var img = canvas.toDataURL("image/PNG");
          var doc = new jsPDF('p', 'pt', 'a4', 1);
          var text = textFile ? textFile : "Extrato de parcelas do empréstimo",
            xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
          doc.text(text, xOffset, 50);
          const bufferX = 20;
          const bufferY = 80;
          const imgProps = (<any>doc).getImageProperties(img);
          const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          doc.addImage(img, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
    
          return doc;
        }).then((doc) => {
          doc.save(nomeDoArquivo + '.pdf');
        });
      }
}